<app-topnav></app-topnav>

<app-data-table [title]="title" [columns]="tableColumns" [filters]="tableFilters" [items]="items" [totalCount]="count"
    [page]="page" [pageSize]="pageSize" [loading]="loading" [filterValues]="tableFilterValues" createLabel="Aggiungi"
    [createLink]="['/admin/users/create']" [editLink]="editLink" [rowActions]="rowActions"
    (pageChange)="handlePageChange($event)" (search)="onTableSearch($event)" (delete)="onDelete($event)"
    (action)="onAction($event)">
</app-data-table>

{{ error }}

<p-drawer [(visible)]="productDialog" position="right" [style]="{ width: '50%' }">
    <ng-template pTemplate="content">
        <div class="p-col-12 p-md-12">
            <p-card>
                <strong>{{ item?.display_name }}</strong>
                <hr />
                <p>{{ item?.user_email }}</p>
                <div class="clearfix"></div><br />
                <button pButton pRipple icon="pi pi-pencil" label="Modifica Dati Cliente"
                    class="p-button p-button-primary p-mr-2" [routerLink]="['/admin/users/edit', item?.id]"></button>
            </p-card>
        </div>
    </ng-template>
</p-drawer>